'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _CatalogCard = require('./CatalogCard');

var _CatalogCard2 = _interopRequireDefault(_CatalogCard);

var _HorizontalCatalogCard = require('./HorizontalCatalogCard');

var _HorizontalCatalogCard2 = _interopRequireDefault(_HorizontalCatalogCard);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CatalogGrid = require('./CatalogGrid.scss');

var _CatalogGrid2 = _interopRequireDefault(_CatalogGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogGrid = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CatalogGrid, _Component);

    function CatalogGrid() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CatalogGrid);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CatalogGrid.__proto__ || (0, _getPrototypeOf2.default)(CatalogGrid)).call.apply(_ref, [this].concat(args))), _this), _this.makeCatalogCards = function () {
            var _this$props = _this.props,
                cardViewModels = _this$props.cardViewModels,
                catalogCardClass = _this$props.catalogCardClass,
                horizontal = _this$props.horizontal,
                trackClick = _this$props.trackClick;


            var lastIndex = _this.props.cardViewModels.length - 1;
            var catalogCardClasses = [].concat((0, _toConsumableArray3.default)(catalogCardClass.split(' ')), [_CatalogGrid2.default.card]).join(' ').trim();

            return cardViewModels.map(function (card, index) {
                var cardProps = {
                    cardViewModel: card,
                    key: index,
                    last: index === lastIndex
                };
                if (horizontal) {
                    return _react2.default.createElement(_HorizontalCatalogCard2.default, cardProps);
                }
                cardProps.className = catalogCardClasses;

                if (trackClick) {
                    cardProps.trackClick = function () {
                        return trackClick(card.catalog.catalogId);
                    };
                }
                return _react2.default.createElement(_CatalogCard2.default, cardProps);
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CatalogGrid, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['catalogCardClass', 'className', 'horizontal', 'cardViewModels']);
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = [].concat((0, _toConsumableArray3.default)(this.props.className.split(' ')), [_CatalogGrid2.default['catalog-grid']]).join(' ').trim();
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, this.makeCatalogCards());
        }
    }]);
    return CatalogGrid;
}(_react.Component), _class.defaultProps = {
    catalogCardClass: '',
    className: '',
    horizontal: false
}, _temp2);
exports.default = CatalogGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogCard/CatalogGrid.js
// module id = zz0d
// module chunks = 57